/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import { CustomTable } from '../../components/Table';
import { Button, Modal, Tag } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { refreshicon } from '../../components/imagepath';
import { matchPermissions } from '../../utils/Permission';
import { GetAllSimulationOTP } from '../../store/Actions/SimulationAction';
import dayjs from 'dayjs';

const { confirm } = Modal;

const SimulationOTP = () => {
    const [EditMembersModal, SetEditMembersModal] = useState(false);
    const dispatch = useDispatch();
    const { simulationOTP, loader } = useSelector(state => state?.Simulation);
    const { userDetails } = useSelector(state => state?.auth);
    const [Refresh, setRefresh] = useState(false);
    const matchPermissionsForUser = matchPermissions(userDetails);
    useEffect(() => {
        dispatch(GetAllSimulationOTP());
    }, [Refresh]);

    const sortedSimulationOTP = [...(simulationOTP || [])].sort((a, b) => {
        return new Date(b.updatedAt) - new Date(a.updatedAt);
    });

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
        },
        {
            title: 'Registration No',
            dataIndex: 'registrationNo',
        },
        {
            title: 'Phone No',
            dataIndex: 'phoneNo',
        },
        {
            title: 'Updated At',
            dataIndex: 'updatedAt',
            render: (text, record) => {
                return (
                    <div>
                        <p>{dayjs(record.updatedAt)?.format('DD-MM-YYYY')}</p>
                        <p>{dayjs(record.updatedAt)?.format('hh:mm A')}</p>
                    </div>
                );
            },
        },
        // {
        //     title: 'Expired Date/Time',
        //     dataIndex: 'expiredDate',
        //     render: (text, record) => {
        //         return (
        //             <div>
        //                 <p>{dayjs(record.expiredDate)?.format('DD-MM-YYYY')}</p>
        //                 <p>{dayjs(record.expiredDate)?.format('hh:mm A')}</p>
        //             </div>
        //         );
        //     },
        // },
        {
            title: 'OTP',
            dataIndex: 'OTP',
            render: (text, record) => {
                return <Tag color={"geekblue"} style={{ fontSize: '12px' }}>{record.OTP || '--'}</Tag>;
            },
        },
    ];
    return (
        <>
            <Header />
            <Sidebar />
            <>
                <div>
                    <div className="page-wrapper">
                        <div className="content">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <ul className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link>Simulation OTP</Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <i className="feather-chevron-right">
                                                    <FeatherIcon icon="chevron-right" />
                                                </i>
                                            </li>
                                            <li className="breadcrumb-item active">Simulation OTP List</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card card-table show-entire">
                                        <div className="card-body">
                                            {/* Table Header */}
                                            <div className="doctor-search-blk">
                                                <div className="add-group">
                                                    <Button
                                                        onClick={() => { setRefresh(!Refresh) }}
                                                        className="btn btn-primary doctor-refresh ms-2"
                                                    >
                                                        <img src={refreshicon} alt="#" />
                                                    </Button>
                                                </div>
                                            </div>

                                            <div className="table-responsive">
                                                <CustomTable
                                                    CurrentPageNum={1}
                                                    TotalPageList={1}
                                                    column={columns}
                                                    dataSource={sortedSimulationOTP}
                                                    dataSourceLength={5}
                                                    pageSize={10}
                                                    loader={loader}
                                                    ShowHeader={true}
                                                    Header={<div className="staff-search-table"></div>}
                                                    key={'hi'}
                                                />

                                                <Modal
                                                    open={EditMembersModal}
                                                    closable={true}
                                                    className="ant-modal"
                                                    forceRender={true}
                                                    zIndex={900}
                                                    style={{ margin: 10 }}
                                                    onOk={() => SetEditMembersModal(false)}
                                                    styles={{
                                                        body: {
                                                            overflow: 'hidden',
                                                        },
                                                        mask: {
                                                            backdropFilter: 'blur(10px)',
                                                        },
                                                        content: {
                                                            borderRadius: 40,
                                                        },
                                                    }}
                                                    okText={'Submit'}
                                                    centered
                                                    confirmLoading={false}
                                                    onCancel={() => SetEditMembersModal(false)}
                                                    closeIcon={true}
                                                ></Modal>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </>
    );
};
export default SimulationOTP;
